document.addEventListener("change", async function(e){

  const input = e.target.closest(".bundle-input");
  if (!input) return;

  const bundleId = input.dataset.bundle;
  let qty = parseInt(input.value, 10);
  const max = parseInt(input.getAttribute("max"), 10);

  if (isNaN(qty) || qty < 0) qty = 0;

  if (max && qty > max) {
    qty = max;
  }

  input.value = qty;

  try {
    const cart = await fetch("/cart.js").then(r => r.json());

    const updates = {};
    const linkedCustomizationIds = []; // Track customization products to update

    cart.items.forEach(item => {
      if (item.properties && item.properties._bundle == bundleId) {
        updates[item.key] = qty;
        
        // Track linking IDs for customization products
        const linkingId = item.properties && item.properties._linking_id;
        const hasCustomization = item.properties && item.properties._has_customization;
        if (linkingId && hasCustomization && !linkedCustomizationIds.includes(linkingId)) {
          linkedCustomizationIds.push(linkingId);
        }
      }
    });

    // Also update linked customization products with the same quantity
    if (linkedCustomizationIds.length > 0) {
      cart.items.forEach(item => {
        const itemMainProductId = item.properties && item.properties._main_product_id;
        const isBundleCustomization = item.properties && item.properties._bundle_customization;
        
        linkedCustomizationIds.forEach(linkedId => {
          if ((isBundleCustomization === 'true' || isBundleCustomization === true) && 
              itemMainProductId === linkedId) {
            updates[item.key] = qty;
          }
        });
      });
    }


    await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ updates })
    });

    // Fetch fresh cart data and dispatch event
    const freshCart = await fetch('/cart.js').then(r => r.json());
    
    // Dispatch cart:change event to notify all listeners
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "bundle:quantity-change",
        cart: freshCart
      }
    }));

    document.dispatchEvent(new CustomEvent("cart:refresh", { detail: freshCart }));

  } catch(err){
    console.log(err);
  }

});


document.addEventListener("click", async function(e){
  const btn = e.target.closest(".bundle-remove");
  if(!btn) return;

  e.preventDefault();

  const bundleId = btn.dataset.bundle;

  try {
    const cart = await fetch('/cart.js').then(r => r.json());

    const updates = {};
    const removedKeys = [];
    const linkedCustomizationIds = []; // Track linking IDs for customization removal

    // First pass: collect bundle items to remove and their linking IDs
    cart.items.forEach(function(item){
      if(item.properties && item.properties._bundle == bundleId){
        updates[item.key] = 0;
        removedKeys.push(item.key);
        
        // Check if this bundle item has customization linking
        const linkingId = item.properties && item.properties._linking_id;
        const hasCustomization = item.properties && item.properties._has_customization;
        
        
        if (linkingId && hasCustomization) {
          linkedCustomizationIds.push(linkingId);
        }
      }
    });


    // Second pass: find and remove linked customization products for bundle customizations
    if (linkedCustomizationIds.length > 0) {
      cart.items.forEach(function(item){
        const itemLinkingId = item.properties && item.properties._linking_id;
        const itemMainProductId = item.properties && item.properties._main_product_id;
        const isBundleCustomization = item.properties && item.properties._bundle_customization;
                
        // Check if this item is a customization product linked to removed bundle items
        linkedCustomizationIds.forEach(function(linkedId){
          // Match customization products: linking_id matches main_product_id (for bundle customizations)
          // Be more flexible - check if this is a customization that links to our bundle
          if ((isBundleCustomization === 'true' || isBundleCustomization === true) && 
              itemMainProductId === linkedId) {
            if (!updates[item.key]) { // Only if not already marked for removal
              updates[item.key] = 0;
              removedKeys.push(item.key);
            }
          }
        });
      });
    }

    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });

    if(!res.ok){
      return;
    }

    /* remove exact rows from drawer for bundle items */
    document.querySelectorAll('.line-item-wrapper[data-cart-bundle-id="' + bundleId + '"]').forEach(function(el){
        el.remove();
    });

    /* Remove customization product rows from DOM */
    // The customization product was marked in updates object, so remove it from DOM
    Object.keys(updates).forEach(function(itemKey){
      if(updates[itemKey] === 0) {
        // Look for line items by their key attribute or data attribute
        const lineItemElement = document.querySelector(
          '[data-line-item-key="' + itemKey + '"],' +
          '[data-cart-item-key="' + itemKey + '"],' +
          'tr[data-line-key="' + itemKey + '"],' +
          '.line-item[data-key="' + itemKey + '"]'
        );
        
        if (lineItemElement) {
          // Get the closest line item wrapper and remove it
          const wrapper = lineItemElement.closest('tr') || 
                         lineItemElement.closest('[class*="cart-drawer"]') ||
                         lineItemElement.closest('.line-item-wrapper') ||
                         lineItemElement;
          
          wrapper.remove();
        }
      }
    });

    /* remove bundle qty / remove controls */
    const controls = document.querySelector(
      `.bundle_quanity_remove[data-bundle-quantity="${bundleId}"]`
    );
    if (controls) controls.remove();

    /* update cart count */
    const freshCart = await fetch('/cart.js').then(r => r.json());

    /* update ALL cart-count tags */
    document.querySelectorAll('cart-count').forEach(function(el){
      el.textContent = freshCart.item_count;
    });

    /* update header wrapper text if needed */
    document.querySelectorAll('.header__cart-count').forEach(function(el){
      const inner = el.querySelector('cart-count');
      if(inner){
        inner.textContent = freshCart.item_count;
      } else {
        el.textContent = freshCart.item_count;
      }
    });

    // Dispatch cart:change event to notify all listeners of the cart update
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "bundle:remove",
        cart: freshCart
      }
    }));
    
    // Also trigger cart refresh event
    document.dispatchEvent(new CustomEvent("cart:refresh", { detail: freshCart }));

  } catch(err){
    console.log(err);
  }

});
